var _g, _path, _polygon, _polygon2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKitchenCabinetRefacing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kitchen-cabinet-refacing",
    viewBox: "0 0 192.3 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156.3 36.6c-0.7 0-1.3-0.6-1.3-1.3v-8.1c0-0.7 0.6-1.3 1.3-1.3s1.3 0.6 1.3 1.3v8.1c-0.1 0.8-0.6 1.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.2 36.6c-0.7 0-1.3-0.6-1.3-1.3v-8.1c0-0.7 0.6-1.3 1.3-1.3s1.3 0.6 1.3 1.3v8.1c0 0.8-0.6 1.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.2 61.1c-2.4 0-4.3-1.9-4.3-4.3v-52c0-2.4 1.9-4.3 4.3-4.3h48.4c2.4 0 4.3 1.9 4.3 4.3v52c0 2.4-1.9 4.3-4.3 4.3h-48.4zm25.4-2.5h22.9c1 0 1.8-0.8 1.8-1.8v-52c0-1-0.8-1.8-1.8-1.8h-22.9v55.6zm-25.4-55.6c-1 0-1.8 0.8-1.8 1.8v52c0 1 0.8 1.8 1.8 1.8h22.9v-55.6h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.9 36.6c-0.7 0-1.3-0.6-1.3-1.3v-8.1c0-0.7 0.6-1.3 1.3-1.3s1.3 0.6 1.3 1.3v8.1c0 0.8-0.6 1.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.9 36.6c-0.7 0-1.3-0.6-1.3-1.3v-8.1c0-0.7 0.6-1.3 1.3-1.3s1.3 0.6 1.3 1.3v8.1c-0.1 0.8-0.6 1.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,61.1c-2.4,0-4.3-1.9-4.3-4.3v-52c0-2.4,1.9-4.3,4.3-4.3h48.4c2.4,0,4.3,1.9,4.3,4.3v52     c0,2.4-1.9,4.3-4.3,4.3H4.8z M30.2,58.6h22.9c1,0,1.8-0.8,1.8-1.8v-52c0-1-0.8-1.8-1.8-1.8H30.2V58.6z M4.8,3C3.8,3,3,3.8,3,4.8     v52c0,1,0.8,1.8,1.8,1.8h22.9V3H4.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m121.7 57.3h-2.8v-0.1c-0.6-3.9-4-6.8-8-6.8h-29.4c-3.9 0-7.4 2.9-8 6.8v0.1h-2.8c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 1.9 1.5 3.4 3.4 3.4h51c1.9 0 3.4-1.5 3.4-3.4v-3.2c0-1.9-1.6-3.4-3.4-3.4zm-44.9 0v-0.2c0.6-2 2.5-3.5 4.6-3.5h29.4c2.1 0 4 1.4 4.6 3.5v0.2h-38.6zm45 6.7h-51.2v-3.4h46.5 0.4 4.3v3.4z",
    fill: "currentColor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "112.2 52.1 79 52.1 81 10.4 110.2 10.4",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.3 3.2 82 3.2 81 10.4 110.3 10.4",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.2 96.5h33.3v6.4h4.1v-6.3h0.8c3-0.1 5.3-2.5 5.3-5.5v-4.1c0-1.1-0.9-2-2-2s-2 0.9-2 2v3.9c0 0.8-0.7 1.5-1.5 1.5h-42.6c-0.8 0-1.5-0.7-1.5-1.5v-3.9c0-1.1-0.9-2-2-2s-2 0.9-2 2v3.9c0 3 2.3 5.4 5.3 5.5h0.8v6.3h4.1v-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156 133.4v-19.9h-119.7v88.5h119.8l-0.1-68.6zm-81.1 64.9h-34.9v-60.7h34.9v60.7zm0.2-64.9h-35.1v-16.8h35v16.8zm38.6 64.9h-34.9v-60.7h34.9v60.7zm0.1-64.9h-35.2v-16.8h35.2v16.8zm3.6-16.8h34.9v16.8h-34.9v-16.8zm35 81.7h-34.9v-60.7h34.9v60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105 167.4c-1 0-1.9 0.8-1.9 1.9v6.7c0 1 0.8 1.9 1.9 1.9s1.9-0.8 1.9-1.9v-6.7c0-1-0.9-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.2 167.4c-1 0-1.9 0.8-1.9 1.9v6.7c0 1 0.8 1.9 1.9 1.9s1.9-0.8 1.9-1.9v-6.7c-0.1-1-0.9-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.2 167.4c-1 0-1.9 0.8-1.9 1.9v6.7c0 1 0.8 1.9 1.9 1.9s1.8-0.9 1.8-1.9v-6.7c0-1-0.8-1.9-1.8-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.2 126.7h4.1c1 0 1.9-0.9 1.9-1.9s-0.9-1.9-1.9-1.9h-4.1c-1 0-1.9 0.9-1.9 1.9s0.8 1.9 1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.1 126.7h4.1c1 0 1.9-0.9 1.9-1.9s-0.9-1.9-1.9-1.9h-4.1c-1 0-1.9 0.9-1.9 1.9s0.8 1.9 1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.4 126.7h4.1c1 0 1.9-0.9 1.9-1.9s-0.9-1.9-1.9-1.9h-4.1c-1 0-1.9 0.9-1.9 1.9s0.8 1.9 1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.5 101.9h-135.4c-2.2 0-4 1.8-4 4v6.8c0 2.2 1.8 4 4 4h135.4c2.2 0 4-1.8 4-4v-6.8c0.1-2.2-1.7-4-4-4zm0.7 10.8c0 0.3-0.3 0.6-0.6 0.6h-135.5c-0.4 0-0.6-0.3-0.6-0.6v-6.8c0-0.4 0.3-0.6 0.6-0.6h135.4c0.3 0 0.6 0.3 0.6 0.6v6.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenCabinetRefacing);
export default __webpack_public_path__ + "static/media/kitchen-cabinet-refacing.c8c10e4c797773d9169e6e58d9b9fd16.svg";
export { ForwardRef as ReactComponent };